export const decisioningStudioAgentsAppGroupIdDsaIdAudiencesGetLatestStats =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/audiences/get_latest_stats";
